import React from "react";
import UsersPage from "../pages/UsersPage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import RegisterPage from "../pages/RegisterPage";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../pages/NotFound";
import Reports from "../pages/Reports";
import SitesLab from "../pages/SiteLabVendors";
import { usePermissionWrapper } from "../hooks/usePermissionWrapper";
import NotAuthorized from "../components/common/NotAuthorized/NotAuthorized";
import AppMain from "../pages/AppMain";
import StudyTabs from "../components/Studies/StudyTabs";
import ForgotPassword from "../pages/ForgotPassword";
import LoginPage from "../pages/LoginPage";
import { useAppSelector, AppState } from "../store";
import AuditTrail from "../pages/AuditTrail";
import AuditTrailDetails from "../pages/AuditTrailDetails";
import Codelists from "../pages/Codelists";
import CodelistValues from "../components/Codelist/CodelistValues";
import SitesLabDetails from "../pages/SitesLabDetails";
import ReportsDetails from "../components/Reports/ReportsDetails";
import ExploratoryAnalysis from "../pages/ExploratoryAnalysis/index";
import Studies from "../pages/Studies";
import Accessions from "../pages/Accessions";
import AccessionDetails from "../components/Accessions/AccessionDetails";
import EnrollmentDetails from "../components/Enrollments/EnrollmentDetails";
import Configuration from "../components/Configuration";
// import AddConfiguration from "../components/Configuration/AddConfiguration";
import Inventory from "../pages/Inventory";
import Enrollments from "../pages/Enrollments";
import InventoryDetails from "../components/Inventory/InventoryDetails";
import AddConnector from "../components/Configuration/AddConnector";
import ExploratoryDetails from "../components/Exploaratory/ExploraotoryDetails";

const MainRoute: React.FC = () => {
  const { checkPermission } = usePermissionWrapper();
  const allUIpermissions: any = useAppSelector(
    (state: AppState) => state.commonSlice.permissions
  );

  const router = createBrowserRouter([
    {
      element: <ProtectedRoute />,
      children: [
        {
          path: "/",
          element: <AppMain />,
          children: [
            {
              index: true,
              element: <Dashboard />,
            },
            {
              path: "users",
              element: checkPermission("VIEW_ALL_USERS") ? (
                <UsersPage />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "studies",
              element: checkPermission("VIEW_ALL_STUDIES") ? (
                <Studies />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "accessions",
              element: <Accessions />,
            },
            {
              path: "enrollment",
              element: <Enrollments />,
            },
            {
              path: "inventory",
              element: <Inventory />,
            },
            {
              path: "reports",
              element: <Reports />,
            },
            {
              path: "sites-lab",
              element: <SitesLab />,
            },
            {
              path: "exploratory-analysis",
              element: <ExploratoryAnalysis />,
            },
            {
              path: "*",
              element: <NotFound />,
            },
            {
              path: "/studies/:study_id",
              element: checkPermission("VIEW_ALL_STUDIES") ? (
                <StudyTabs />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/accessions/:accession_id",
              element: <AccessionDetails />,
            },
            {
              path: "enrollment/:enrollment_id",
              element: <EnrollmentDetails />,
            },
            {
              path: "/sites-lab/:id",
              element: <SitesLabDetails />,
            },
            {
              path: "/inventory/:id",
              element: <InventoryDetails />,
            },
            {
              path: "/reports/:id",
              element: <ReportsDetails />,
            },
            {
              path: "/exploratory-analysis/:exploratory_id",
              element: <ExploratoryDetails />,
            },
            {
              path: "audit",
              element: checkPermission("VIEW_AUDIT_TRAIL") ? (
                <AuditTrail />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "audit/:audit_id",
              element: checkPermission("VIEW_AUDIT_TRAIL") ? (
                <AuditTrailDetails />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "codelists",
              element: checkPermission("VIEW_ALL_CODELISTS") ? (
                <Codelists />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "codelists/:code_list_code",
              element: checkPermission("VIEW_ALL_CODELISTS") ? (
                <CodelistValues />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/configuration",
              element: checkPermission("MANAGE_CONFIGURATIONS") ? (
                <Configuration />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/configuration/ui-config",
              element: checkPermission("MANAGE_CONFIGURATIONS") ? (
                <Configuration />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/configuration/connectors",
              element: checkPermission("MANAGE_CONFIGURATIONS") ? (
                <Configuration />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/configuration/transformation",
              element: checkPermission("MANAGE_CONFIGURATIONS") ? (
                <Configuration />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/configuration/connectors/add-connector",
              element: checkPermission("MANAGE_CONFIGURATIONS") ? (
                <AddConnector />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
            {
              path: "/configuration/connectors/:connector_id",
              element: checkPermission("MANAGE_CONFIGURATIONS") ? (
                <AddConnector />
              ) : (
                allUIpermissions.length > 0 && <NotAuthorized />
              ),
            },
          ],
        },
      ],
    },

    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/register",
      element: <RegisterPage />,
    },
    {
      path: "/forgotPassword",
      element: <ForgotPassword />,
    },
  ]);
  return <RouterProvider router={router} />;
};

export default MainRoute;
